var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.045 21.315c-1.01-1.485-1.868-2.725-2.597-3.779-1.301-1.882-2.192-3.169-2.8-4.194-.468-.79-.75-1.396-.918-1.973-.168-.574-.23-1.144-.23-1.869 0-3.873 3.092-7 6.891-7 3.8 0 6.892 3.127 6.892 7 0 .725-.063 1.295-.23 1.869-.169.577-.45 1.183-.919 1.973-.608 1.025-1.498 2.312-2.8 4.194-.729 1.054-1.587 2.294-2.596 3.779a.417.417 0 01-.693 0zm.346-8.19c1.984 0 3.58-1.63 3.58-3.625s-1.596-3.625-3.58-3.625-3.58 1.63-3.58 3.625 1.596 3.625 3.58 3.625z",
    stroke: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.ad21e52321036ade8cb3ec78733bebe5.svg";
export { ForwardRef as ReactComponent };